module.exports = __webpack_public_path__ + "media/bootstrap-icons/rulers-8a7ca9ec.svg";